import usersActions from './actionTypes'
import usersMutations from './mutationTypes'
import http from '../../../services/http'
import apiFunctions from '../../../helpers/apiFunctions'
import generalActions from '../general/actionTypes'

const actions = {
  [usersActions.FETCH_USERS]: async ({ dispatch, commit }) => {
    const response = await http.get('/users/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(usersMutations.SET_USERS, { response })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [usersActions.FETCH_PAGINATED_USERS]: async ({ state, commit, dispatch }, { page, perPage, searchQuery }) => {
    let params = {}
    if (page) {
      params['page'] = page
    }
    if (perPage) {
      params['per_page'] = perPage
    }
    if (searchQuery) {
      params['search_query'] = searchQuery
    }
    let esc = encodeURIComponent
    let query = Object.keys(params)
      .map(k => `${esc(k)}=${esc(params[k])}`)
      .join('&')
    const response = await http.get(`/users/?${query}`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(usersMutations.SET_USERS, { response })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [usersActions.FETCH_ROLES]: async ({ commit, dispatch }) => {
    const response = await http.get('/users/roles/')
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      commit(usersMutations.SET_ROLES, { response })
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [usersActions.DELETE_USER]: async ({ state, commit, dispatch }, data) => {
    const response = http.put(`/users/${data.id}/`, data)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [usersActions.FETCH_USER]: async ({ rootState, commit, dispatch }, id) => {
    const response = http.get(`/users/${id}/`)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [usersActions.UPDATE_USER]: async ({ rootState, commit, dispatch }, data) => {
    const response = http({ ...data })
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [usersActions.SEND_PASSWORD_RESET]: async ({ rootState, commit, dispatch }, data) => {
    const response = http.post('/auth/request-change-password/', data)
    const responseObject = apiFunctions.checkIfResponseFailed(response)
    if (!responseObject.failed) {
      return response
    } else {
      dispatch(generalActions.SET_ERROR)
    }
  },
  [usersActions.SET_LOGIN_ERROR]: async ({ state, commit }, data) => {
    commit(usersMutations.SET_LOGIN_ERROR, data)
  }
}

export default {
  ...actions
}
